import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgZoomInOutline = function SvgZoomInOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99463 11C2.99463 6.58173 6.57636 3 10.9946 3C15.4129 3 18.9946 6.58173 18.9946 11C18.9946 12.9387 18.3042 14.7174 17.157 16.1017L20.525 19.4697C20.8179 19.7626 20.8179 20.2374 20.525 20.5303C20.2321 20.8232 19.7572 20.8232 19.4643 20.5303L16.0963 17.1624C14.712 18.3096 12.9334 19 10.9946 19C6.57636 19 2.99463 15.4183 2.99463 11ZM10.9946 4.5C7.40478 4.5 4.49463 7.41015 4.49463 11C4.49463 14.5899 7.40478 17.5 10.9946 17.5C12.7897 17.5 14.4137 16.7733 15.5908 15.5962C16.7679 14.4191 17.4946 12.7951 17.4946 11C17.4946 7.41015 14.5845 4.5 10.9946 4.5ZM10.9946 7C11.4088 7 11.7446 7.33579 11.7446 7.75V10.25H14.2446C14.6588 10.25 14.9946 10.5858 14.9946 11C14.9946 11.4142 14.6588 11.75 14.2446 11.75H11.7446V14.25C11.7446 14.6642 11.4088 15 10.9946 15C10.5804 15 10.2446 14.6642 10.2446 14.25V11.75H7.74463C7.33042 11.75 6.99463 11.4142 6.99463 11C6.99463 10.5858 7.33042 10.25 7.74463 10.25H10.2446V7.75C10.2446 7.33579 10.5804 7 10.9946 7Z"
  })));
};

export { SvgZoomInOutline as ReactComponent };
//# sourceMappingURL=zoom--in-outline.svg.js.map
